import { useNavigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { HandByeIcon, CheckOutlineIcon } from 'Asset/icon';

import { TextMedium, TextSemiBold } from 'UiKit/typography';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const HelpHost = ({ dataStatusHelp, isHideNavBar = true, isLivestreaming = false }) => {
  const { t } = useTranslation('host-help-partner');
  const navigate = useNavigate();

  const isRequestingHelpHost = dataStatusHelp?.mappedStatus === 'SEARCHING' || dataStatusHelp?.status === 'NO_ACTIVE_OPERATORS';
  const isAssignedHelpHost = dataStatusHelp?.mappedStatus === 'ASSIGNED';

  const isOperatorExist = dataStatusHelp?.activeOperators?.length > 0;
  const progressText = isOperatorExist ? t('help_host_widget.progress_text') : t('help_host_widget.progress_no_operator_text');

  const bottomMargin = isHideNavBar ? '40px' : '72px';

  const redirectPath = isLivestreaming ? '/host/stream' : '/host/help-request-form';

  const onClick = () => navigate(redirectPath);

  return (
    <Condition
      statement={isAssignedHelpHost}
      fallback={
        <Condition statement={isRequestingHelpHost} fallback={null}>
          <Box className={styles['help-host__container']} onClick={onClick} bottom={bottomMargin}>
            <HandByeIcon color="var(--color-primary50)" />
            <Box className={styles['help-host__text-container']}>
              <TextSemiBold className={styles['help-host__text']}>{progressText}</TextSemiBold>
              <TextMedium className={styles['help-host__sub-text']}>{t('help_host_widget.subtitle')}</TextMedium>
            </Box>
          </Box>
        </Condition>
      }
    >
      <Box className={styles['help-host__container']} onClick={onClick} bottom={bottomMargin}>
        <CheckOutlineIcon size="22px" color="var(--color-success50)" />
        <Box className={styles['help-host__text-container']}>
          <TextSemiBold className={styles['help-host__text']}>
            {dataStatusHelp?.operatorName} {t('help_host_widget.success_text')}
          </TextSemiBold>
          <TextMedium className={styles['help-host__sub-text']}>{t('help_host_widget.subtitle')}</TextMedium>
        </Box>
      </Box>
    </Condition>
  );
};

export default HelpHost;
